/* eslint-disable no-sequences */
import React, { useEffect, useState } from "react";
import Return from "../../../images/return.png";
import LogoFuncionalidades from "../../../images/logoFuncionalidades.png";
import { BaSeButton, BaSeIcon, BaSeTag } from "@base/react";
import { AddFuncionalidadesModel } from "./addFuncionalidade.model";
import { mapValueMsg } from "./mapsValuesPage";
import { formatDefaultValueSelect } from "../../../utils/mask";
// import { formatDateToBRWithHour } from '../../../utils/time';
import { formatDateToBR } from "../../../utils/time";
import styles from "./styles.module.scss";
import { Chip, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

export const DEFAULT_VALUE_SELECIONE = "Selecione";
export const DEFAULT_VALUE_ALL = "Todos";

export const AddFuncionalidade = (props) => {
  const { onClose, selectedRow, allValuesOptions, typeScreen } = props;

  const {
    funcionalidade,
    setFuncionalidade,
    isLoadingCidades,
    cidades,
    updateValue,
    recoveredByid,
    adicionarNotificacao,
    onChangeUF,
    updatePics,
    // isCPF,
    setIsCPF,
    planilha,
    setPlanilha,
    // funcoesBackup,
    // setFuncoesBackup,
    newCPF,
    setNewCPF,
    // newCNPJ,
    // setNewCNPJ,
    removeCPF,
    tipoPessoa,
    setTipoPessoa,
    isLoading,
    // filterMenu,
    updatePlanilha,
  } = AddFuncionalidadesModel({ selectedRow, typeScreen, onClose });

  const [UF, setUF] = useState(null);

  // prettier-ignore
  useEffect(_ => {
    const valueUF = funcionalidade?.ufs?.[0]?.id;
    // prettier-ignore
    if (valueUF && (valueUF !== UF)) {
      onChangeUF(allValuesOptions.ufs, funcionalidade?.ufs?.[0]?.id);
      setUF(valueUF);
    }

    // if(tipoPessoa === 'PESSOA_JURIDICA'){
    //   funcionalidade?.portes?.[0]?.id
    // }

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [funcionalidade]);

  const backList = () => {
    onClose();
  };

  return (
    <div>
      <div className={styles.container_principal}>
        <div
          className={styles.filtro_container}
          style={{ backgroundColor: "#CC3366" }}
        >
          <div className={styles.modal_flex_direction_row}>
            <img
              alt="imagem"
              className={styles.logo_funcionalidade_add}
              // style={{ width: '5%' }}
              src={LogoFuncionalidades}
            />
            <h2 className={styles.text_color_branco_titulo}>Funcionalidades</h2>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.icons_acoes_modal_filtro}>
                <img
                  onClick={backList}
                  alt="imagem"
                  className={styles.writin}
                  src={Return}
                />
                <p className={styles.text_color_branco}>Voltar</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.div_tabelas_Addfuncionalidades_filtro}>
          <div className={styles.separator}>
            <h3>{mapValueMsg[typeScreen]}</h3>
          </div>

          {/* Inputs INCLUIR/EDITAR */}
          <div className={styles.big_container_funcionalidades}>
            <div className={styles.content_left_func}>
              {/* Título */}
              <div className={styles.content_title}>
                <div>
                  <label htmlFor="input-title">Título</label>
                  <span className={styles.mandatory_func}>*</span>
                </div>

                <input
                  value={funcionalidade?.nome ?? ""}
                  id="input-title"
                  onChange={(evento) => {
                    const newValue = evento.target.value;
                    if (newValue.length < 141)
                      updateValue("nome", evento.target.value);
                  }}
                  placeholder="Digite aqui o título"
                />
                <p className={styles.sublabel}>
                  {funcionalidade?.nome?.length ?? 0}/140
                </p>
              </div>

              {/* Descrição */}
              <div className={styles.content_descricao}>
                <div>
                  <label htmlFor="input-descricao">Descrição</label>
                  <span className={styles.mandatory_func}>*</span>
                </div>
                <textarea
                  rows="5"
                  value={funcionalidade?.descricao ?? ""}
                  id="input-descricao"
                  onChange={(evento) => {
                    const newValue = evento.target.value;
                    if (newValue.length < 501)
                      updateValue("descricao", newValue);
                  }}
                  placeholder="Descrição da funcionalidade"
                />
                <p className={styles.sublabel}>
                  {funcionalidade?.descricao?.length ?? 0}/500
                </p>
              </div>

              {/* Serviços */}
              <div className={styles.content_service}>
                <div>
                  <label htmlFor="input-descricao">Serviço</label>
                  <span className={styles.mandatory_func}>*</span>
                </div>
                <select
                  value={funcionalidade?.idFuncao ?? ""}
                  className="btn-select-funcionalidades"
                  onChange={(event) => {
                    updateValue("idFuncao", parseInt(event.target.value));
                  }}
                >
                  <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                  {allValuesOptions &&
                    allValuesOptions.funcoes
                      .sort((a, b) => a.menu.localeCompare(b.menu))
                      .map((fco) => {
                        return (
                          <option value={fco.id} title={fco.funcao}>
                            {formatDefaultValueSelect(fco.funcao)}
                          </option>
                        );
                      })}
                </select>
              </div>
            </div>

            <div className={styles.content_right_func}>
              {/* MENU */}
              <div className={styles.content_menu}>
                <div>
                  <label htmlFor="input-menu">Menu</label>
                  <span className={styles.mandatory_func}>*</span>
                </div>
                <select
                  value={funcionalidade?.menu ?? ""}
                  onChange={(event) => {
                    const recovered = event.target.value;
                    updateValue("menu", recovered);
                  }}
                  id="input-menu"
                >
                  <option value={""}>{DEFAULT_VALUE_SELECIONE}</option>
                  {allValuesOptions?.menus &&
                    allValuesOptions?.menus.map((menu) => (
                      <option value={menu} title={menu}>
                        {formatDefaultValueSelect(menu)}
                      </option>
                    ))}
                </select>
              </div>

              {/* PALAVRA CHAVE */}
              <div className={styles.content_plChave}>
                <div style={{ marginBottom: "3px" }}>
                  <label htmlFor="tags-filled">Palavras-chave</label>
                  <span className={styles.mandatory_func}>*</span>
                </div>
                <div className={styles.auto_complete_area}>
                  <Autocomplete
                    multiple
                    size="small"
                    id="tags-filled"
                    filterSelectedOptions
                    limitTags={5}
                    options={allValuesOptions?.palavrasChave
                      .filter(
                        (item) =>
                          !funcionalidade?.palavrasChave?.find(
                            (i) => i.palavra === item.palavra
                          )
                      )
                      .map((pc) => pc.palavra)}
                    onChange={(event, newValue) => {
                      let newVal = funcionalidade.palavrasChave ?? [];
                      if (newValue.length < newVal.length) {
                        newVal = newValue;
                      } else {
                        newVal.push(
                          allValuesOptions?.palavrasChave.filter(
                            (item) =>
                              !funcionalidade?.palavrasChave?.find(
                                (i) => i.palavra === item.palavra
                              )
                          )[event.target.id.split("-")[3]]
                        );
                      }
                      updateValue("palavrasChave", newVal);
                    }}
                    value={funcionalidade?.palavrasChave ?? []}
                    // freeSolo
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          variant="outlined"
                          label={option.palavra}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Selecione"
                      />
                    )}
                  />
                </div>
              </div>

              {/* PARCEIRO/PROVEDOR */}
              <div className={styles.content_parceiro}>
                <div>
                  <label htmlFor="input-parceiro">Parceiro/Provedor</label>
                  <span className={styles.mandatory_func}>*</span>
                </div>
                <select
                  value={funcionalidade?.parceiro?.id ?? ""}
                  className="btn-select-funcionalidades "
                  onChange={(event) => {
                    const recovered = recoveredByid(
                      allValuesOptions.parceiros,
                      event.target.value,
                      true
                    );
                    updateValue("parceiro", recovered[0]);
                  }}
                  id="input-parceiro"
                >
                  <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                  {allValuesOptions.parceiros &&
                    allValuesOptions.parceiros.map((pco) => (
                      <option value={pco.id} title={pco.nome}>
                        {pco.nome}
                      </option>
                    ))}
                </select>
              </div>

              <div className={styles.content_img_upload}>
                <div className={styles.subContent_img}>
                  <div>
                    <div>
                      <label htmlFor="input-image">Imagem</label>
                      {/* <span className={styles.mandatory_func}>*</span> */}
                    </div>
                    <input
                      id="input-image"
                      className={styles.hide_input}
                      accept="image/*"
                      type="file"
                      onChange={(event) => updatePics("uploadImagem", event)}
                    />
                    <div className={styles.image_container}>
                      {funcionalidade?.uploadImagem?.base64 == null &&
                      funcionalidade?.imagem?.urlConteudo == null ? (
                        <p
                          style={{
                            fontSize: 14,
                            color: "#B3B3B380",
                            padding: 5,
                          }}
                        >
                          Faça o upload da imagem que será exibida...
                        </p>
                      ) : null}

                      {funcionalidade?.uploadImagem?.base64 ? (
                        <img
                          src={`data:image/png;base64, ${funcionalidade?.uploadImagem?.base64}`}
                          alt=""
                        />
                      ) : (
                        funcionalidade?.imagem?.urlConteudo && (
                          <img
                            src={funcionalidade?.imagem?.urlConteudo}
                            alt=""
                          />
                        )
                      )}
                    </div>
                  </div>
                  <div className={styles.image_upload_icon}>
                    <label for="input-image" id={styles.label_icon}>
                      {/* <BaSeIcon
                        size={22}
                        name="image-upload"
                        color="#CC3366"
                        description="teste"
                      /> */}
                      <svg
                        width="25"
                        height="23"
                        viewBox="0 0 25 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.5917 20.0895C21.9008 20.7806 20.9694 21.1862 19.9196 21.1862C18.9182 21.1862 17.9869 20.7806 17.3193 20.1362C17.2242 20.041 17.1291 19.9208 17.0322 19.8256C16.9604 19.7538 16.8886 19.6587 16.8168 19.5869C16.7217 19.4666 16.6499 19.3248 16.5781 19.1812C16.5297 19.0861 16.483 19.0143 16.4346 18.9191C16.3861 18.8007 16.3395 18.6571 16.3161 18.5135C16.2928 18.4183 16.2443 18.2981 16.221 18.2029C16.1726 17.9642 16.1492 17.7021 16.1492 17.4401C16.1492 16.39 16.5781 15.4602 17.2475 14.7673C17.9151 14.0762 18.8698 13.6705 19.9196 13.6705C20.9694 13.6705 21.899 14.0996 22.5917 14.7673C23.2844 15.4602 23.69 16.39 23.69 17.4401C23.69 18.4668 23.2611 19.3966 22.5917 20.0895ZM3.33967 20.041C2.76721 20.041 2.2414 19.8023 1.86096 19.4199C1.50384 19.0376 1.26516 18.5135 1.26516 17.9409V14.9827L5.48776 10.7357L9.08944 14.3383C9.32812 14.577 9.73369 14.577 9.99569 14.3383L15.3166 8.99277L18.7998 12.5002C18.728 12.5235 18.6562 12.5487 18.5844 12.572C18.4893 12.5953 18.3942 12.6205 18.274 12.6671C18.1789 12.6905 18.0838 12.7389 17.9887 12.7623C17.9169 12.7856 17.8684 12.8107 17.7984 12.8574C17.7033 12.9059 17.6315 12.9292 17.5598 12.9759C17.4413 13.0477 17.3211 13.1195 17.2026 13.1913C17.1309 13.2397 17.0824 13.2631 17.0124 13.3098C16.964 13.3331 16.9406 13.3582 16.894 13.3816C16.6786 13.5252 16.4884 13.6921 16.3215 13.8824C15.4153 14.7888 14.8428 16.0543 14.8428 17.4616C14.8428 17.8188 14.8912 18.1527 14.9612 18.5117C14.9846 18.6068 15.0097 18.6786 15.033 18.7737C15.1048 19.0125 15.1766 19.2512 15.2717 19.49V19.5133C15.3668 19.7036 15.4619 19.919 15.5822 20.0859H3.34326V20.0374L3.33967 20.041ZM1.88429 2.23817C2.26653 1.85583 2.79054 1.6171 3.363 1.6171H17.2008C17.7733 1.6171 18.2973 1.85583 18.6796 2.23817C19.0618 2.6205 19.3005 3.14464 19.3005 3.71725V11.1629L15.7688 7.63036C15.5301 7.39162 15.1245 7.36829 14.8625 7.63036L9.54167 12.9759L5.93999 9.34818C5.70131 9.10944 5.29574 9.08611 5.03374 9.34818L1.26337 13.1662V3.69212C1.26337 3.11951 1.50205 2.59537 1.88429 2.23637V2.23817ZM20.5638 12.4284V3.69392C20.5638 2.7641 20.1816 1.92763 19.5858 1.30836C18.9649 0.687284 18.1304 0.330078 17.2008 0.330078H3.363C2.43342 0.330078 1.59716 0.712414 0.978034 1.30836C0.357117 1.92943 0 2.7641 0 3.69392V17.9409C0 18.8707 0.382241 19.7071 0.978034 20.3264C1.59895 20.9475 2.43342 21.3047 3.363 21.3047H16.7468C17.6297 22.0209 18.7262 22.4732 19.9429 22.4732C21.3499 22.4732 22.615 21.9006 23.5213 20.9942C24.4275 20.0877 25 18.8222 25 17.4149C25 16.0076 24.4275 14.7422 23.5213 13.8357C22.7101 13.0728 21.6837 12.5702 20.5638 12.4284Z"
                          fill="#CC3366"
                        />
                        <path
                          d="M20.3714 14.862C20.323 14.8135 20.253 14.7669 20.1561 14.7184C20.0843 14.6951 20.0125 14.6699 19.9407 14.6699C19.9174 14.6699 19.9174 14.6699 19.9174 14.6699C19.8941 14.6699 19.8941 14.6699 19.8941 14.6699C19.8223 14.6699 19.7505 14.6933 19.6787 14.7184C19.607 14.7417 19.5352 14.7902 19.4634 14.862L17.9847 16.3411C17.746 16.5798 17.746 16.9855 17.9847 17.2475C18.2233 17.4863 18.6289 17.4863 18.8909 17.2475L19.2732 16.8652V19.4895C19.2732 19.8467 19.5585 20.1339 19.9174 20.1339C20.2745 20.1339 20.5617 19.8467 20.5617 19.4895V16.8652L20.9439 17.2475C21.1826 17.4863 21.5881 17.4863 21.8501 17.2475C22.0888 17.0088 22.0888 16.6031 21.8501 16.3411L20.3714 14.862Z"
                          fill="#CC3366"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.7703 6.11004L8.80566 9.07538V3.14648L11.7703 6.11004Z"
                          fill="#CC3366"
                        />
                      </svg>
                    </label>
                  </div>
                </div>

                <div className={styles.subContent_img}>
                  <div>
                    <div>
                      <label htmlFor="input-icon">Logo</label>
                      {/* <span className={styles.mandatory_func}>*</span> */}
                    </div>
                    <input
                      id="input-icon"
                      className={styles.hide_input}
                      accept="image/*"
                      type="file"
                      onChange={(event) => updatePics("uploadIcon", event)}
                    />
                    <div className={styles.image_container}>
                      {funcionalidade?.uploadIcon?.base64 == null &&
                      funcionalidade?.icone?.urlConteudo == null ? (
                        <p
                          style={{
                            fontSize: 14,
                            color: "#B3B3B380",
                            padding: 5,
                          }}
                        >
                          Faça o upload da logo que será exibida...
                        </p>
                      ) : null}
                      {funcionalidade?.uploadIcon?.base64 ? (
                        <img
                          src={`data:image/png;base64, ${funcionalidade?.uploadIcon?.base64}`}
                          alt=""
                        />
                      ) : (
                        funcionalidade?.icone?.urlConteudo && (
                          <img
                            src={funcionalidade?.icone?.urlConteudo}
                            alt=""
                          />
                        )
                      )}
                    </div>
                  </div>
                  <div className={styles.image_upload_icon}>
                    <label
                      for="input-icon"
                      // className="image-upload-icon"
                      id={styles.label_icon}
                    >
                      {/* <BaSeIcon
                        size={22}
                        name="image-upload"
                        color="#CC3366"
                        description="teste"
                      /> */}
                      <svg
                        width="25"
                        height="23"
                        viewBox="0 0 25 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.5917 20.0895C21.9008 20.7806 20.9694 21.1862 19.9196 21.1862C18.9182 21.1862 17.9869 20.7806 17.3193 20.1362C17.2242 20.041 17.1291 19.9208 17.0322 19.8256C16.9604 19.7538 16.8886 19.6587 16.8168 19.5869C16.7217 19.4666 16.6499 19.3248 16.5781 19.1812C16.5297 19.0861 16.483 19.0143 16.4346 18.9191C16.3861 18.8007 16.3395 18.6571 16.3161 18.5135C16.2928 18.4183 16.2443 18.2981 16.221 18.2029C16.1726 17.9642 16.1492 17.7021 16.1492 17.4401C16.1492 16.39 16.5781 15.4602 17.2475 14.7673C17.9151 14.0762 18.8698 13.6705 19.9196 13.6705C20.9694 13.6705 21.899 14.0996 22.5917 14.7673C23.2844 15.4602 23.69 16.39 23.69 17.4401C23.69 18.4668 23.2611 19.3966 22.5917 20.0895ZM3.33967 20.041C2.76721 20.041 2.2414 19.8023 1.86096 19.4199C1.50384 19.0376 1.26516 18.5135 1.26516 17.9409V14.9827L5.48776 10.7357L9.08944 14.3383C9.32812 14.577 9.73369 14.577 9.99569 14.3383L15.3166 8.99277L18.7998 12.5002C18.728 12.5235 18.6562 12.5487 18.5844 12.572C18.4893 12.5953 18.3942 12.6205 18.274 12.6671C18.1789 12.6905 18.0838 12.7389 17.9887 12.7623C17.9169 12.7856 17.8684 12.8107 17.7984 12.8574C17.7033 12.9059 17.6315 12.9292 17.5598 12.9759C17.4413 13.0477 17.3211 13.1195 17.2026 13.1913C17.1309 13.2397 17.0824 13.2631 17.0124 13.3098C16.964 13.3331 16.9406 13.3582 16.894 13.3816C16.6786 13.5252 16.4884 13.6921 16.3215 13.8824C15.4153 14.7888 14.8428 16.0543 14.8428 17.4616C14.8428 17.8188 14.8912 18.1527 14.9612 18.5117C14.9846 18.6068 15.0097 18.6786 15.033 18.7737C15.1048 19.0125 15.1766 19.2512 15.2717 19.49V19.5133C15.3668 19.7036 15.4619 19.919 15.5822 20.0859H3.34326V20.0374L3.33967 20.041ZM1.88429 2.23817C2.26653 1.85583 2.79054 1.6171 3.363 1.6171H17.2008C17.7733 1.6171 18.2973 1.85583 18.6796 2.23817C19.0618 2.6205 19.3005 3.14464 19.3005 3.71725V11.1629L15.7688 7.63036C15.5301 7.39162 15.1245 7.36829 14.8625 7.63036L9.54167 12.9759L5.93999 9.34818C5.70131 9.10944 5.29574 9.08611 5.03374 9.34818L1.26337 13.1662V3.69212C1.26337 3.11951 1.50205 2.59537 1.88429 2.23637V2.23817ZM20.5638 12.4284V3.69392C20.5638 2.7641 20.1816 1.92763 19.5858 1.30836C18.9649 0.687284 18.1304 0.330078 17.2008 0.330078H3.363C2.43342 0.330078 1.59716 0.712414 0.978034 1.30836C0.357117 1.92943 0 2.7641 0 3.69392V17.9409C0 18.8707 0.382241 19.7071 0.978034 20.3264C1.59895 20.9475 2.43342 21.3047 3.363 21.3047H16.7468C17.6297 22.0209 18.7262 22.4732 19.9429 22.4732C21.3499 22.4732 22.615 21.9006 23.5213 20.9942C24.4275 20.0877 25 18.8222 25 17.4149C25 16.0076 24.4275 14.7422 23.5213 13.8357C22.7101 13.0728 21.6837 12.5702 20.5638 12.4284Z"
                          fill="#CC3366"
                        />
                        <path
                          d="M20.3714 14.862C20.323 14.8135 20.253 14.7669 20.1561 14.7184C20.0843 14.6951 20.0125 14.6699 19.9407 14.6699C19.9174 14.6699 19.9174 14.6699 19.9174 14.6699C19.8941 14.6699 19.8941 14.6699 19.8941 14.6699C19.8223 14.6699 19.7505 14.6933 19.6787 14.7184C19.607 14.7417 19.5352 14.7902 19.4634 14.862L17.9847 16.3411C17.746 16.5798 17.746 16.9855 17.9847 17.2475C18.2233 17.4863 18.6289 17.4863 18.8909 17.2475L19.2732 16.8652V19.4895C19.2732 19.8467 19.5585 20.1339 19.9174 20.1339C20.2745 20.1339 20.5617 19.8467 20.5617 19.4895V16.8652L20.9439 17.2475C21.1826 17.4863 21.5881 17.4863 21.8501 17.2475C22.0888 17.0088 22.0888 16.6031 21.8501 16.3411L20.3714 14.862Z"
                          fill="#CC3366"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.7703 6.11004L8.80566 9.07538V3.14648L11.7703 6.11004Z"
                          fill="#CC3366"
                        />
                      </svg>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.separator}>
            <h3>Abrangência da funcionalidade</h3>
          </div>
          <div className={styles.div_acoes_funcionalidade}>
            <div className={styles.container_itens}>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div>
                  <p className={styles.text_campos_cadastro}>UF:</p>
                  <select
                    value={funcionalidade?.ufs?.[0]?.id ?? ""}
                    // className="btn-select-funcionalidades uf-func-style"
                    className={styles.uf_func_style}
                    onChange={(event) => {
                      onChangeUF(allValuesOptions.ufs, event.target.value);
                      // setUF(event.target.value);
                    }}
                  >
                    <option value={""}>Todas</option>
                    {allValuesOptions?.ufs.map((uf) => (
                      <option value={uf.id} title={uf.nome}>
                        {uf.sigla}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <p className={styles.text_campos_cadastro}>Cidade:</p>
                  <select
                    // disabled={true}
                    value={funcionalidade?.cidades?.[0]?.id ?? ""}
                    // className="btn-select-funcionalidades cidade-fun-style"
                    className={styles.cidade_fun_style}
                    onChange={(event) => {
                      const recovered = recoveredByid(
                        cidades,
                        event.target.value,
                        false
                      );
                      updateValue("cidades", [recovered]);
                    }}
                  >
                    {isLoadingCidades ? (
                      <option value={""}>Carregando cidades</option>
                    ) : (
                      <>
                        <option value={""}>Todas</option>
                        {cidades.map((cidade) => (
                          <option value={cidade.id} title={cidade.nome}>
                            {cidade.nome}
                          </option>
                        ))}
                      </>
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className={styles.container_itens}>
              <div className={styles.btn_addUpdate_func}>
                <BaSeButton
                  color="#CC3366"
                  value={
                    isLoading
                      ? "Enviando ..."
                      : typeScreen === 3
                      ? "Editar Funcionalidade"
                      : "Incluir Funcionalidade"
                  }
                  onClick={() => !isLoading && adicionarNotificacao()}
                  isDisabled={
                    isLoading || !funcionalidade?.palavrasChave?.length
                      ? true
                      : false
                  }
                />
              </div>
            </div>
          </div>
          <div className={styles.div_acoes_funcionalidade}>
            <div className={styles.container_itens}>
              <p className={styles.text_campos_cadastro}>Tipo de usuário</p>
              <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <input
                    id="cpf"
                    type="radio"
                    value={tipoPessoa === "PESSOA_FISICA"}
                    name="isCPF"
                    checked={tipoPessoa === "PESSOA_FISICA"}
                    onChange={() => {
                      setIsCPF(true);
                      setFuncionalidade({
                        ...funcionalidade,
                        cnpjs: [null],
                        portes: [null],
                        cnaes: [null],
                        segmentos: [null],
                      });
                      setTipoPessoa("PESSOA_FISICA");
                      updateValue("tipoPessoa", "PESSOA_FISICA");
                    }}
                  />
                  <label className={styles.margin_left5_color_label} for="cpf">
                    CPF
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginLeft: 10,
                  }}
                >
                  <input
                    id="cnpj"
                    type="radio"
                    name="isCPF"
                    value={tipoPessoa === "PESSOA_JURIDICA"}
                    checked={tipoPessoa === "PESSOA_JURIDICA"}
                    onChange={() => {
                      setIsCPF(false);
                      setFuncionalidade({
                        ...funcionalidade,
                        cpfs: [],
                      });
                      setTipoPessoa("PESSOA_JURIDICA");
                      updateValue("tipoPessoa", "PESSOA_JURIDICA");
                    }}
                  />
                  <label
                    className={styles.margin_left5_color_label}
                    style={{ marginRight: "1.9rem" }}
                    for="cnpj"
                  >
                    CNPJ
                  </label>

                  {/* Adicionar nome avulso */}
                  <input
                    placeholder={
                      tipoPessoa === "PESSOA_FISICA"
                        ? "Insira um CPF"
                        : "Insira um CNPJ"
                    }
                    type="text"
                    onChange={(event) => setNewCPF(event.target.value)}
                    value={newCPF}
                    className={styles.margin_left20}
                  />

                  <div className={styles.margin_left5}>
                    <BaSeIcon
                      name="plus-circle"
                      size={35}
                      color="#6c6c6c"
                      description="Ícone de adicionar CPF"
                      onClick={() =>
                        setPlanilha([...planilha, newCPF ?? [newCPF]])
                      }
                    />
                  </div>
                  <label for="planilha" className={styles.text_list_tipoPessoa}>
                    {/* <BaSeIcon
                      name="document"
                      size={22}
                      color="#6c6c6c"
                      description="Ícone de adicionar lista"
                    /> */}
                    {`Envie uma lista de ${
                      tipoPessoa === "PESSOA_JURIDICA" ? "CNPJs" : "CPFs"
                    }`}{" "}
                    <span
                      style={{
                        color: "#fff",
                        backgroundColor: "#CC3366",
                        borderRadius: "0.25rem",
                        padding: "5px",
                        marginLeft: "1rem",
                      }}
                    >
                      XLS
                    </span>
                  </label>

                  {/* input de planilha escondido */}
                  <input
                    type="file"
                    id="planilha"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    onChange={(event) => updatePlanilha(event)}
                    className={styles.hide_input}
                  />
                </div>
              </div>
            </div>

            <div className={styles.container_itens}>
              <div className={styles.cpfs_container}>
                {planilha &&
                  planilha.length > 0 &&
                  planilha.map((cpf, index) => (
                    <BaSeTag
                      borderColor="transparent"
                      iconBackgroundColor="#db340b"
                      iconColor="#ffffff"
                      label={cpf}
                      labelBackgroundColor="#cfe2fc"
                      labelColor="#005eb8"
                      onClose={() => removeCPF(index)}
                      size="medium"
                    />
                  ))}
              </div>
            </div>
          </div>
          {tipoPessoa === "PESSOA_JURIDICA" && (
            <div className={styles.div_acoes_funcionalidade}>
              <div className={styles.container_itens}>
                <p className={styles.text_campos_cadastro}>Porte</p>
                <select
                  value={funcionalidade?.portes?.[0]?.id ?? ""}
                  className="btn-select-funcionalidades"
                  onChange={(event) => {
                    const recovered = recoveredByid(
                      allValuesOptions.portes,
                      event.target.value,
                      true
                    );

                    updateValue("portes", recovered);
                  }}
                >
                  <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                  {allValuesOptions.portes &&
                    allValuesOptions.portes.map((porte) => (
                      <option value={porte.id} title={porte.nomePorte}>
                        {porte.nomePorte}
                      </option>
                    ))}
                </select>
              </div>

              <div className={styles.container_itens}>
                <p className={styles.text_campos_cadastro}>CNAE</p>
                <select
                  value={funcionalidade?.cnaes?.[0]?.id ?? ""}
                  className="btn-select-funcionalidades "
                  onChange={(event) => {
                    const recovered = recoveredByid(
                      allValuesOptions.cnaes,
                      event.target.value,
                      true
                    );
                    updateValue("cnaes", recovered);
                  }}
                >
                  <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                  {allValuesOptions.cnaes &&
                    allValuesOptions.cnaes.map((cnae) => (
                      <option value={cnae.id} title={cnae.descricao}>
                        {cnae.descricao}
                      </option>
                    ))}
                </select>
              </div>
              <div className={styles.container_itens}>
                <p className={styles.text_campos_cadastro}>Segmentos</p>
                <select
                  value={funcionalidade?.segmentos?.[0]?.id ?? ""}
                  className="btn-select-funcionalidades "
                  onChange={(event) => {
                    // const recovered = recoveredByid(
                    //   allValuesOptions.segmentos,
                    //   event.target.value,
                    //   true
                    // );
                    // updateValue('segmentos', recovered);
                    updateValue("segmentos", parseInt(event.target.value));
                    if (event.target.value !== DEFAULT_VALUE_SELECIONE) {
                      const recovered = recoveredByid(
                        allValuesOptions.segmentos,
                        event.target.value,
                        true
                      );

                      // setCnaes(recovered?.[0].cnaes);
                      updateValue("segmentos", recovered);
                    } else {
                      // setCnaes([]);
                    }
                  }}
                >
                  <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                  {allValuesOptions.segmentos &&
                    allValuesOptions.segmentos.map((seg) => (
                      <option value={seg.id} title={seg.nome}>
                        {seg.nome}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          )}
          <div className={styles.div_acoes_funcionalidade}>
            <div className={styles.container_itens}>
              <p className={styles.text_campos_cadastro}>Usuários que </p>
              <select
                value={funcionalidade?.usuariosQue ?? ""}
                // className="btn-select-funcionalidades userQue-func-style"
                className={styles.userQue_func_style}
                onChange={(event) => {
                  updateValue("usuariosQue", event.target.value);
                }}
              >
                <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                {allValuesOptions?.usuariosQue &&
                  allValuesOptions?.usuariosQue?.map((uq) => (
                    <option value={uq} title={uq}>
                      {formatDefaultValueSelect(uq)}
                    </option>
                  ))}
              </select>
            </div>
            <div className="accordion-content flex-1 column"></div>
          </div>
        </div>

        <div className={styles.updatedAt_funcionalidade_container}>
          {funcionalidade.atualizadoPor && typeScreen === 3 && (
            <h5>
              Atualizado em {formatDateToBR(funcionalidade.ultimaAtualizacao)}{" "}
              por {funcionalidade?.atualizadoPor?.nome}
            </h5>
          )}
          {funcionalidade.criadoPor && typeScreen === 3 && (
            <h5>
              Criado em {formatDateToBR(funcionalidade.dataCriacao)} por{" "}
              {funcionalidade?.criadoPor?.nome}
            </h5>
          )}
        </div>
      </div>
    </div>
  );
};
